import React from 'react';

const CardContext = React.createContext(null);

export default CardContext;
